(function(){
  var LIME = "#ccff33";
  var ICONS = {
    home:'<path d="M3 11l9-8 9 8"></path><path d="M5 10v10h14V10"></path>',
    search:'<circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path>',
    shop:'<path d="M4 7h16l-1 13H5L4 7z"></path><path d="M9 7a3 3 0 0 1 6 0"></path>',
    account:'<circle cx="12" cy="8" r="3.4"></circle><path d="M5.5 20a6.5 6.5 0 0 1 13 0"></path>',
    bag:'<path d="M6 7h12l-1 14H7L6 7z"></path><path d="M9 7a3 3 0 0 1 6 0"></path>'
  };
  function svg(p){return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg>';}
  var CSS = [
    "@media (max-width:989px){",
    "body{padding-bottom:calc(70px + env(safe-area-inset-bottom,0px)) !important}",
    "#rp-tabbar{position:fixed;left:0;right:0;bottom:0;background:rgba(255,255,255,.95);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);border-top:1px solid #ededed;display:flex;align-items:flex-start;justify-content:space-around;padding:9px 4px env(safe-area-inset-bottom,0px);z-index:6;font-family:inherit}",
    "#rp-tabbar .rp-tb{display:flex;flex-direction:column;align-items:center;gap:4px;color:#111;font-size:9.5px;font-weight:600;flex:1;text-decoration:none;position:relative;padding:2px 0 8px;background:none;border:0;cursor:pointer;font-family:inherit;line-height:1}",
    "#rp-tabbar .rp-tb svg{display:block}",
    "#rp-tabbar .rp-tb .rp-dot{position:absolute;top:-7px;width:5px;height:5px;border-radius:50%;background:transparent}",
    "#rp-tabbar .rp-tb.rp-on .rp-dot{background:"+LIME+"}",
    "#rp-tabbar .rp-cnt{position:relative;display:block}",
    "#rp-tabbar .rp-badge{position:absolute;top:-5px;right:-10px;background:"+LIME+";color:#111;font-size:9px;font-weight:800;border-radius:999px;min-width:15px;height:15px;line-height:15px;text-align:center;padding:0 4px;display:none}",
    "}",
    "@media (min-width:990px){#rp-tabbar{display:none !important}body{padding-bottom:0 !important}}"
  ].join("");
  function tabHTML(id, tag, href, label){
    var open = '<' + tag + ' class="rp-tb" data-id="'+id+'"' + (href ? ' href="'+href+'"' : ' type="button"') + '>';
    var close = '</' + tag + '>';
    var inner = '<span class="rp-dot"></span>';
    if(id === "bag"){
      inner += '<span class="rp-cnt">' + svg(ICONS.bag) + '<span class="rp-badge" id="rp-bag-count">0</span></span>';
    } else {
      inner += svg(ICONS[id]);
    }
    inner += '<span>' + label + '</span>';
    return open + inner + close;
  }
  function injectCSS(){
    if(document.getElementById("rp-tabbar-css")) return;
    var st = document.createElement("style");
    st.id = "rp-tabbar-css";
    st.textContent = CSS;
    (document.head||document.documentElement).appendChild(st);
  }
  function activeId(){
    var p = location.pathname;
    if(p === "/" || p === "") return "home";
    if(p.indexOf("/search") === 0) return "search";
    if(p.indexOf("/account") === 0) return "account";
    if(p.indexOf("/cart") === 0) return "bag";
    if(p.indexOf("/collections") === 0 || p.indexOf("/products") === 0) return "shop";
    return "";
  }
  function openMenu(){
    var s = document.querySelector(".header__icon--menu, header-drawer summary");
    if(s){ s.click(); return true; }
    return false;
  }
  function updateCart(){
    if(!window.fetch) return;
    fetch("/cart.js", {credentials:"same-origin"}).then(function(r){return r.json();}).then(function(c){
      var b = document.getElementById("rp-bag-count");
      if(!b) return;
      var n = c && c.item_count ? c.item_count : 0;
      if(n > 0){ b.textContent = n > 99 ? "99+" : String(n); b.style.display = "block"; }
      else { b.style.display = "none"; }
    }).catch(function(){});
  }
  function syncHidden(){
    var tb = document.getElementById("rp-tabbar");
    if(!tb) return;
    var open = /overflow-hidden/.test(document.body.className) || document.querySelector("header-drawer details[open]");
    tb.style.display = open ? "none" : "";
  }
  function build(){
    injectCSS();
    if(document.getElementById("rp-tabbar")) return;
    var bar = document.createElement("nav");
    bar.id = "rp-tabbar";
    bar.setAttribute("aria-label", "Quick navigation");
    bar.innerHTML =
      tabHTML("home", "a", "/", "Home") +
      tabHTML("search", "a", "/search", "Search") +
      tabHTML("shop", "button", null, "Shop") +
      tabHTML("account", "a", "/account", "Account") +
      tabHTML("bag", "a", "/cart", "Bag");
    document.body.appendChild(bar);
    var act = activeId();
    var tabs = bar.querySelectorAll(".rp-tb");
    for(var i=0;i<tabs.length;i++){ if(tabs[i].getAttribute("data-id") === act) tabs[i].classList.add("rp-on"); }
    var shop = bar.querySelector('[data-id="shop"]');
    if(shop){
      shop.addEventListener("click", function(e){
        e.preventDefault();
        if(!openMenu()){ location.href = "/collections/all"; }
      });
    }
    updateCart();
  }
  function boot(){
    build();
    updateCart();
    document.addEventListener("click", function(){ setTimeout(updateCart, 700); }, true);
    document.addEventListener("cart:updated", updateCart);
    document.addEventListener("cart:refresh", updateCart);
    if(window.MutationObserver){
      var obs = new MutationObserver(function(){ if(!document.getElementById("rp-tabbar")) build(); syncHidden(); });
      obs.observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:["class","open"]});
    }
    setInterval(function(){ if(!document.getElementById("rp-tabbar")) build(); syncHidden(); }, 1200);
  }
  if(document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
})();
